<template>
  <v-card class="pa-4" elevation="0" rounded="lg">
    <v-card-title class="text-h5 font-weight-bold primary--text">
      {{ edit ? "Editar Claves Administrador" : "Nueva Clave Administrador" }}
    </v-card-title>
    <v-divider class="mb-4"></v-divider>

    <v-card-text>
      <v-overlay v-if="loader">
        <v-progress-circular
          indeterminate
          size="64"
          color="primary"
        ></v-progress-circular>
      </v-overlay>

      <v-form @submit.prevent="checkForm">
        <v-container>
          <v-row>
            <v-col cols="12">
              <v-text-field
                v-model="Nomb"
                label="Nombre de la clave"
                outlined
                dense
                prepend-icon="mdi-account"
                :error-messages="errors.nombre"
                hide-details
                required
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="6">
              <v-select
                label="Departamento"
                v-model="departmentId"
                :items="departments"
                outlined
                dense
                hide-details
                item-text="Nombre"
                item-value="id"
              ></v-select>
            </v-col>
            <v-col cols="4">
              <v-text-field
                label="Codigo de departamento"
                v-model="ACCS['DEPT~~CONT']"
                outlined
                dense
                hide-details
                item-text="Nombre"
                item-value="id"
              ></v-text-field>
            </v-col>
            <v-col cols="2" class="d-flex align-center justify-center">
              <v-btn
                color="primary"
                class="pb-3"
                icon
                :disabled="!departmentId || !ACCS['DEPT~~CONT']"
                x-large
                @click="handleTreeItems(false)"
              >
                <v-icon> mdi-plus-circle</v-icon>
              </v-btn>
            </v-col>
          </v-row>
          <v-row v-if="treeItems.length > 0">
            <v-col cols="12">
              <div class="text-subtitle-1 font-weight-bold mb-2">Accesos</div>
              <v-sheet outlined rounded="md" class="pa-2">
                <v-treeview
                  :items="treeItems"
                  item-key="id"
                  open-all
                  dense
                  hoverable
                >
                  <template v-slot:label="{ item }">
                    <v-row align="center" no-gutters class="py-1">
                      <v-col
                        cols="7"
                        class="text-body-2 font-weight-medium text-truncate"
                      >
                        {{ item.name }}
                      </v-col>
                      <v-col cols="4">
                        <v-text-field
                          v-if="item.hasSeparator"
                          v-model="item.digits"
                          label="Código"
                          dense
                          outlined
                          hide-details
                          class="digits-input"
                          maxlength="4"
                          v-mask="'####'"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="1">
                        <v-btn
                          icon
                          @click="handleTreeItems(true, item.id)"
                        >
                          <v-icon color="error"> mdi-close-circle </v-icon>
                        </v-btn>
                      </v-col>
                    </v-row>
                  </template>
                </v-treeview>
              </v-sheet>
            </v-col>
          </v-row>

          <v-row v-else-if="edit" justify="center">
            <v-col cols="12" class="text-center grey--text">
              No se encontraron accesos configurados.
            </v-col>
          </v-row>

          <v-row justify="end" class="mt-4">
            <v-btn
              color="grey lighten-1"
              @click="$emit('toggle', false)"
              class="mr-2 text-none"
            >
              Cancelar
            </v-btn>
            <v-btn color="primary" type="submit" class="text-none">
              Guardar
            </v-btn>
          </v-row>
        </v-container>
      </v-form>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: "ClavesAdminForm",
  props: ["edit", "dataEdit"],
  data() {
    return {
      Nomb: "",
      ACCS: {},
      treeItems: [],
      loader: false,
      id: "",
      errors: {},
      departmentId: null,
    };
  },
  methods: {
    cleanForm() {
      this.Nomb = "";
      this.ACCS = {};
      this.treeItems = [];
      this.id = "";
      this.errors = {};
      this.departmentId = null;
    },
    checkForm: function (e) {
      if (e) e.preventDefault();
      let valid = true;

      this.errors = {};

      if (!this.Nomb) {
        this.errors.nombre = "El nombre es obligatorio";
        valid = false;
      }

      if (valid) {
        let doAction = "CREATE";
        if (this.edit) {
          doAction = "EDIT";
        }

        const accsObj = this.treeToObject(this.treeItems);

        const dataToSave = {
          id: this.id,
          Nomb: this.Nomb,
          ["ACCS~~CONT"]: accsObj,
        };

        this.$emit("successData", dataToSave, doAction);
      }
    },
    handleTreeItems(del, id) {
      if (del) {
        this.treeItems = this.treeItems.filter((i) => i.id !== id);
      } else {
        if (!this.departmentId || !this.ACCS["DEPT~~CONT"]) {
          return;
        }

        const departmentName = this.departments.find(
          (d) => d.id === this.departmentId,
        )?.Nombre;
        const existingIndex = this.treeItems.findIndex(
          (i) => i.id === `${this.departmentId}`,
        );

        if (existingIndex !== -1) {
          this.treeItems[existingIndex].name = departmentName;
          this.treeItems[existingIndex].digits = this.ACCS["DEPT~~CONT"] || "";
        } else {
          this.treeItems.push({
            id: `${this.departmentId}`,
            name: departmentName,
            digits: this.ACCS["DEPT~~CONT"] || "",
            hasSeparator: true,
          });
        }
      }
    },
    objectToTree(obj, parentId = "") {
      const items = [];
      let idCounter = 1;

      for (const key in obj) {
        const parts = key.split("~~");
        const name = parts[0];
        const digits = parts[1] || "";
        const currentId = parentId
          ? `${parentId}-${idCounter}`
          : `${idCounter}`;
        idCounter++;

        const item = {
          id: currentId,
          name: name,
          digits: digits,
          hasSeparator: key.includes("~~"),
          originalKey: key,
          value: obj[key],
          isLeaf: typeof obj[key] !== "object" || obj[key] === null,
        };

        if (!item.isLeaf) {
          item.children = this.objectToTree(obj[key], currentId);
        }

        items.push(item);
      }
      return items;
    },
    treeToObject(items) {
      const obj = {};
      items.forEach((item) => {
        const key = item.hasSeparator
          ? `${item.name}~~${item.digits}`
          : item.name;
        if (!item.isLeaf && item.children && item.children.length > 0) {
          obj[key] = this.treeToObject(item.children);
        } else {
          obj[key] = item.value;
        }
      });
      return obj;
    },
  },
  computed: {
    departments() {
      return this.$store.getters.getPDVDepartamentos;
    },
  },
  mounted() {
    this.loader = false;
    if (this.edit) {
      this.Nomb = this.dataEdit.Nomb;
      this.id = this.dataEdit.id;
      this.ACCS = this.dataEdit["ACCS~~CONT"] || {};
      this.treeItems = this.objectToTree(this.ACCS);
    }
  },
};
</script>

<style scoped>
.digits-input >>> .v-input__control {
  min-height: 30px !important;
}

.digits-input >>> .v-input__slot {
  min-height: 30px !important;
  padding: 0 8px !important;
}

.digits-input >>> input {
  padding: 4px 0 !important;
  text-align: center;
}
</style>
